import styled from 'styled-components'

export const MatchGroupStyled = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.content.border};
  border-radius: ${({ theme }) =>
    theme.box.borderRadius(theme.typography.htmlFontSize || 16)};
  padding: ${({ theme }) => theme.space.medium};
`
